import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";
import * as styles from "./PostsListing.module.scss";

const PostListing = ({ postEdges }) => {
  const getPostList = () => {
    const postList = [];
    postEdges.forEach((postEdge) => {
      postList.push({
        path: postEdge.node.fields.slug,
        tags: postEdge.node.frontmatter.tags,
        categories: postEdge.node.frontmatter.categories,
        cover: postEdge.node.frontmatter.cover.childImageSharp.fluid,
        title: postEdge.node.frontmatter.title,
        date: postEdge.node.fields.date,
        excerpt: postEdge.node.excerpt,
        timeToRead: postEdge.node.timeToRead,
      });
    });
    return postList;
  };

  const postList = getPostList();
  // console.log(postList)
  return (
    <div className={styles.articleList}>
      {
        /* Your post list here. */
        postList.map((post) => (
          <Link to={post.path} key={post.title}>
            <article className={styles.articleBox}>
              {post.cover ? (
                <Img className={styles.featureImg} fluid={post.cover} />
              ) : (
                ""
              )}
              <div className={styles.right}>
                <h3>{post.title}</h3>
                <div className={styles.meta}>
                  {post.date}
                  {/* &mdash; <span>{post.categories.join(' / ')}</span> */}
                  &mdash; تأخذ {post.timeToRead} دقائق
                  {/* &mdash;{' '} */}
                  {/* <img
                  className={styles.pageview}
                  src={`https://views.show/svg?key=${post.path.substr(1)}`}
                /> */}
                </div>
                <p>{post.excerpt}</p>
              </div>
            </article>
          </Link>
        ))
      }
    </div>
  );
};

export default PostListing;
